import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@nextiva/next-ui-components';

import { InvoicesList, InvoicesFilter } from 'components';
import { AFTER_INVOICES_LABEL, EARLIER_INVOICES_LABEL } from 'constant';

import './Invoices.scss';

export const blockName = 'invoices';

const Invoices = props => {
  const {
    startAddInvoices,
    addGlobalWarning,
    startGetInvoicePDF,
    invoices,
    isMoonshotActive,
    moonshotInvoiceFlag,
    toggleMoonshotFlag,
    totalElements,
    billToSiteNumber,
  } = props;

  return (
    <div className={`${blockName}`} id={blockName} data-testid={blockName}>
      {isMoonshotActive && (
        <div
          className={`${blockName}__toggle-button`}
          data-testid={`${blockName}__toggle-button`}
          onClick={toggleMoonshotFlag}
        >
          <Button color="primary">
            {moonshotInvoiceFlag
              ? EARLIER_INVOICES_LABEL
              : AFTER_INVOICES_LABEL}
          </Button>
        </div>
      )}

      <InvoicesFilter
        addGlobalWarning={addGlobalWarning}
        startAddInvoices={startAddInvoices}
        setDateFilter={props.setDateFilter}
        setInvoiceNameFilter={props.setInvoiceNameFilter}
        billToSiteNumber={billToSiteNumber}
      />
      <article
        className={`${blockName}__list-header`}
        data-testid={`${blockName}__list-header`}
      >
        <p className={`${blockName}__large-column`}>Invoice</p>
        <p>Date</p>
        <p>Type</p>
        <p className={`${blockName}__short-column`}>Status</p>
        <p className={`${blockName}__short-column`}>Amount</p>
      </article>
      <InvoicesList
        startAddInvoices={startAddInvoices}
        invoices={invoices}
        totalElements={totalElements}
        startGetInvoicePDF={startGetInvoicePDF}
      />
    </div>
  );
};
Invoices.defaultProps = {
  billToSiteNumber: '',
};

Invoices.propTypes = {
  invoices: PropTypes.array.isRequired,
  isMoonshotActive: PropTypes.bool.isRequired,
  moonshotInvoiceFlag: PropTypes.bool.isRequired,
  startAddInvoices: PropTypes.func.isRequired,
  totalElements: PropTypes.number.isRequired,
  setDateFilter: PropTypes.func.isRequired,
  setInvoiceNameFilter: PropTypes.func.isRequired,
  toggleMoonshotFlag: PropTypes.func.isRequired,
  addGlobalWarning: PropTypes.func.isRequired,
  startGetInvoicePDF: PropTypes.func.isRequired,
  billToSiteNumber: PropTypes.string.isRequired,
};

export default Invoices;
